/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ManualProCreate = {
    properties: {
        expirationDate: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        userId: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
